import { Grid } from "@mui/material";
import React from "react";
import { getAssets } from "@unisearch/helpers";
import styles from "./styles/exam_banner2.module.scss";
import Image from "next/legacy/image";

export const ExamBanner2 = () => {
  return (
    <section className={styles.wrapper}>
      <div className="container">
        <Grid container spacing={2} alignItems="center">
          <Grid item sm={12} md={6}>
            <h4 className={styles.sub_heading}>
              Your One-Stop English Language Workshop
            </h4>
            <h1 className={styles.heading}>
              Hit Your Target <span className="mark"> English Scores</span> with{" "}
              Confidence
            </h1>
            <p className={styles.sub_text}>
              From detailed guides breaking down the major English language
              proficiency tests to eBooks, online courses, and live workshops,
              you’re at the right place to polish up your ability in English!
            </p>
            {/* <button className="btn btn-secondary btn-bg btn-secondary-box-shadow">
              Free Trial
            </button> */}
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <Image
                layout="responsive"
                width={577}
                height={580}
                blurDataURL={getAssets(
                  "assets/images/study/country_placeholder.webp"
                )}
                placeholder="blur"
                src={getAssets("/assets/images/exam/student1.webp")}
                alt={"banner"}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ExamBanner2;
